//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[],[[["num_libraries"],"GetSearchLibraries",{R_:{user_libraries:""}},0,0],[["user_libraries"],"SetSearchLibraries",{},1,0],[["definition"],"InitializeDisplayToAbsoluteTemperatureFunctionDefinition",{},1,0],[["definition"],"AddDisplayToAbsoluteTemperatureFunction",{},1,0]],[]];
SPLM.Preferences.RulePreferences = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.RulePreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.RulePreferences.AbsoluteTemperatureConversionDefinition = class{
    constructor(mathFunctionName,canReturnUnits,canHaveOptionalBaseParameter,canHaveOptionalUseUnitsParameter,optionLocation,isDependentOnOptionalParameter,notConvertingParameterWithNoOption,notConvertingParameterIfOptionIsOff,isFinalAdjustmentNotNeccessaryIfUnitless,dontConvertParameterLastResort,addCelsiusToMissingParameters){
        this.mathFunctionName=mathFunctionName;this.canReturnUnits=canReturnUnits;this.canHaveOptionalBaseParameter=canHaveOptionalBaseParameter;this.canHaveOptionalUseUnitsParameter=canHaveOptionalUseUnitsParameter;this.optionLocation=optionLocation;this.isDependentOnOptionalParameter=isDependentOnOptionalParameter;this.notConvertingParameterWithNoOption=notConvertingParameterWithNoOption;this.notConvertingParameterIfOptionIsOff=notConvertingParameterIfOptionIsOff;this.isFinalAdjustmentNotNeccessaryIfUnitless=isFinalAdjustmentNotNeccessaryIfUnitless;this.dontConvertParameterLastResort=dontConvertParameterLastResort;this.addCelsiusToMissingParameters=addCelsiusToMissingParameters;}
    get Mathfunctionname(){return this.mathFunctionName}
    set Mathfunctionname(val){this.mathFunctionName = val}
    get Canreturnunits(){return this.canReturnUnits}
    set Canreturnunits(val){this.canReturnUnits = val}
    get Canhaveoptionalbaseparameter(){return this.canHaveOptionalBaseParameter}
    set Canhaveoptionalbaseparameter(val){this.canHaveOptionalBaseParameter = val}
    get Canhaveoptionaluseunitsparameter(){return this.canHaveOptionalUseUnitsParameter}
    set Canhaveoptionaluseunitsparameter(val){this.canHaveOptionalUseUnitsParameter = val}
    get Optionlocation(){return this.optionLocation}
    set Optionlocation(val){this.optionLocation = val}
    get Isdependentonoptionalparameter(){return this.isDependentOnOptionalParameter}
    set Isdependentonoptionalparameter(val){this.isDependentOnOptionalParameter = val}
    get Notconvertingparameterwithnooption(){return this.notConvertingParameterWithNoOption}
    set Notconvertingparameterwithnooption(val){this.notConvertingParameterWithNoOption = val}
    get Notconvertingparameterifoptionisoff(){return this.notConvertingParameterIfOptionIsOff}
    set Notconvertingparameterifoptionisoff(val){this.notConvertingParameterIfOptionIsOff = val}
    get Isfinaladjustmentnotneccessaryifunitless(){return this.isFinalAdjustmentNotNeccessaryIfUnitless}
    set Isfinaladjustmentnotneccessaryifunitless(val){this.isFinalAdjustmentNotNeccessaryIfUnitless = val}
    get Dontconvertparameterlastresort(){return this.dontConvertParameterLastResort}
    set Dontconvertparameterlastresort(val){this.dontConvertParameterLastResort = val}
    get Addcelsiustomissingparameters(){return this.addCelsiusToMissingParameters}
    set Addcelsiustomissingparameters(val){this.addCelsiusToMissingParameters = val}
};

export default SPLM;